import React, { useState } from 'react';
import { useQuery } from 'react-query';
import api from '../services/api';
import { MagnifyingGlassIcon, FunnelIcon } from '@heroicons/react/24/outline';

const fetchPayments = (params) => api.get('/payments', { params }).then(res => res.data.data);

export default function Payments() {
  const [filters, setFilters] = useState({ page: 1, limit: 20 });

  const { data, isLoading } = useQuery(['payments', filters], () => fetchPayments(filters));

  const transactions = data?.transactions || [];
  const pagination = data?.pagination || {};

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-slate-900">Payment Transactions</h1>
        <p className="mt-1 text-sm text-slate-500">View all payment transactions</p>
      </div>

      <div className="card">
        <div className="card-body">
          <div className="flex flex-col sm:flex-row gap-4">
            <div className="flex-1 relative">
              <MagnifyingGlassIcon className="absolute left-3 top-1/2 -translate-y-1/2 h-5 w-5 text-slate-400" />
              <input
                type="text"
                placeholder="Search by transaction number, challan..."
                className="input-field pl-10"
                onChange={(e) => setFilters({ ...filters, search: e.target.value, page: 1 })}
              />
            </div>
            <input
              type="date"
              className="input-field"
              onChange={(e) => setFilters({ ...filters, fromDate: e.target.value, page: 1 })}
            />
          </div>
        </div>
      </div>

      <div className="card">
        <div className="table-container">
          <table className="data-table">
            <thead>
              <tr>
                <th>Transaction #</th>
                <th>Challan</th>
                <th>Consumer</th>
                <th>Amount</th>
                <th>Date</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-200 bg-white">
              {isLoading ? (
                <tr><td colSpan="6" className="text-center py-8">Loading...</td></tr>
              ) : transactions.length === 0 ? (
                <tr><td colSpan="6" className="text-center py-8 text-slate-500">No transactions found</td></tr>
              ) : (
                transactions.map((txn) => (
                  <tr key={txn.id} className="hover:bg-slate-50">
                    <td className="font-mono text-xs">{txn.transactionNumber}</td>
                    <td>{txn.challanNo}</td>
                    <td>{txn.bill?.consumerName}</td>
                    <td className="font-medium">PKR {parseFloat(txn.paymentAmount).toLocaleString()}</td>
                    <td>{new Date(txn.postedAt).toLocaleDateString()}</td>
                    <td>
                      <span className="badge badge-green">{txn.statusCode}</span>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
